<body class="location-admin">
  <app-table-header
    [headerText]="headerText"
    [hasRadioButton]="hasRadioButton"
    [radioHeader]="radioHeader"
    [firstOptionValue]="firstOptionValue"
    [firstOptionName]="firstOptionName"
    [secondOptionValue]="secondOptionValue"
    [secondOptionName]="secondOptionName"
    [radioModel]="radioModel"
    [filterDisabled]="!isFilterEnabled"
    [hasAddItem]="isAdminSearch"
    [addItemDisabled]="!canAddLocations"
    [rightPadding]="7"
    (exportRadioButtonChange)="emitRadioButtonChange($event)"
    (clearFilterEvent)="clearAllFilters()"
    (exportExcelEvent)="exportExcel()"
    (addItemEvent)="addLocation()"
  ></app-table-header>
  <div
    class="location-admin-table-container"
    [ngClass]="{ 'admin-search-screen': isAdminSearch }"
  >
    <!-- Table -->
    <table mat-table [dataSource]="dataSource" class="location-admin-table">
      <!-- Location Code -->
      <ng-container matColumnDef="locationCode">
        <th mat-header-cell *matHeaderCellDef class="location-code-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.LOCATION_CODE"
            [control]="locationCodeData.formControl"
            [maxLength]="10"
            [allowedSpecialChars]="SPECIAL_CHARS.ALPHABET_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="location-headers"
          class="left-data-column"
        >
          {{ admin.locationCode }}
        </td>
      </ng-container>

      <!-- Location Name -->
      <ng-container matColumnDef="locationName">
        <th mat-header-cell *matHeaderCellDef class="location-name-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.LOCATION_NAME"
            [control]="locationNameData.formControl"
            [maxLength]="30"
            [allowedSpecialChars]="SPECIAL_CHARS.SPACE"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="location-name-headers"
          class="left-data-column"
        >
          {{ admin.locationName }}
        </td>
      </ng-container>

      <!-- PKG SLIC -->
      <ng-container matColumnDef="pkgSlic">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-search-component
            [columnName]="COLUMNTEXT.PACKAGE_SLIC"
            [control]="packageSlicData.formControl"
            [maxLength]="5"
            [allowedSpecialChars]="SPECIAL_CHARS.ALPHABET_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="pkg-slic-headers"
          class="left-data-column"
        >
          {{ admin.pkgSlic }}
        </td>
      </ng-container>

      <!-- HUB SLIC -->
      <ng-container matColumnDef="hubSlic">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-search-component
            [columnName]="COLUMNTEXT.HUB_SLIC"
            [control]="hubSlicData.formControl"
            [maxLength]="5"
            [allowedSpecialChars]="SPECIAL_CHARS.ALPHABET_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="hub-slic-headers"
          class="left-data-column"
        >
          {{ admin.hubSlic }}
        </td>
      </ng-container>

      <!-- Mnemonic -->
      <ng-container matColumnDef="mnemonic">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-search-component
            [columnName]="COLUMNTEXT.MNEMONIC"
            [control]="mnemonicData.formControl"
            [maxLength]="5"
            [allowedSpecialChars]="SPECIAL_CHARS.ALPHABET_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="mnemonic-headers"
          class="left-data-column"
        >
          {{ admin.mnemonic }}
        </td>
      </ng-container>

      <!--Group Code-->
      <ng-container matColumnDef="locationGroups">
        <th mat-header-cell *matHeaderCellDef class="location-group-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.LOCATION_GROUPS_CODE"
            [control]="locationGroupsData.formControl"
            [maxLength]="5"
            [textInputWidth]="100"
            [searchIconOffset]="17"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          class="groups"
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="group-code-headers"
        >
          {{ admin.locationGroups.toString() }}
        </td>
      </ng-container>

      <!-- Country -->
      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-search-component
            [columnName]="COLUMNTEXT.COUNTRY"
            [control]="countryData.formControl"
            [maxLength]="2"
            [allowedSpecialChars]="SPECIAL_CHARS.ALPHABET_ONLY"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="country-headers"
          class="left-data-column"
        >
          {{ admin.country }}
        </td>
      </ng-container>

      <!-- Region -->
      <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-search-component
            [columnName]="COLUMNTEXT.REGION"
            [control]="regionData.formControl"
            [maxLength]="2"
            [allowedSpecialChars]="SPECIAL_CHARS.NUMBER_ONLY"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="region-headers"
          class="left-data-column"
        >
          {{ admin.region }}
        </td>
      </ng-container>

      <!-- District -->
      <ng-container matColumnDef="district">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-search-component
            [columnName]="COLUMNTEXT.DISTRICT"
            [control]="districtData.formControl"
            [maxLength]="2"
            [allowedSpecialChars]="SPECIAL_CHARS.NUMBER_ONLY"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="district-headers"
          class="left-data-column"
        >
          {{ admin.district }}
        </td>
      </ng-container>

      <!-- Setup -->
      <ng-container matColumnDef="locationSetup">
        <th mat-header-cell *matHeaderCellDef class="setup-headers">
          <app-table-header-dropdown
            [columnText]="COLUMNTEXT.SETUP"
            [itemId]="setupData.itemId"
            [searchResults]="setup"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[0]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 0)
            "
            (checkboxesUpdated)="onStatusChangeForDropdowns($event, setupData)"
          >
          </app-table-header-dropdown>
        </th>
        <td
          mat-cell
          *matCellDef="let location"
          headers="setup-headers"
          class="left-data-column"
        >
          {{ location.locationSetup }}
        </td>
      </ng-container>

      <!-- Messaging -->
      <ng-container matColumnDef="messaging">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-dropdown-status
            [header]="COLUMNTEXT.MESSAGING"
            [data]="messagingData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="72"
            [showDropdown]="dropdownOpen[1]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 1)
            "
            (emitStatusChange)="
              onStatusChangeForDropdowns($event, messagingData)
            "
          >
          </app-table-dropdown-status>
        </th>
        <td
          mat-cell
          *matCellDef="let location; let i = index"
          headers="messaging-headers"
        >
          @if (location.messaging === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else {
            <img alt="false" [src]="IMAGES.CANCEL" />
          }
        </td>
      </ng-container>

      <!-- GIO -->
      <ng-container matColumnDef="gioEnabled">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-dropdown-status
            [header]="COLUMNTEXT.GIO"
            [data]="gioData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="72"
            [showDropdown]="dropdownOpen[2]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 2)
            "
            (emitStatusChange)="onStatusChangeForDropdowns($event, gioData)"
          >
          </app-table-dropdown-status>
        </th>
        <td
          mat-cell
          *matCellDef="let location; let i = index"
          headers="gio-headers"
        >
          @if (location.gioEnabled === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else {
            <img alt="false" [src]="IMAGES.CANCEL" />
          }
        </td>
      </ng-container>

      <!-- BYOD -->
      <ng-container matColumnDef="byod">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-dropdown-status
            [header]="COLUMNTEXT.BYOD"
            [data]="byodData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="72"
            [showDropdown]="dropdownOpen[3]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 3)
            "
            (emitStatusChange)="onStatusChangeForDropdowns($event, byodData)"
          >
          </app-table-dropdown-status>
        </th>
        <td
          mat-cell
          *matCellDef="let location; let i = index"
          headers="byod-headers"
        >
          @if (location.byod === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else {
            <img alt="false" [src]="IMAGES.CANCEL" />
          }
        </td>
      </ng-container>

      <!-- IDO -->
      <ng-container matColumnDef="ido">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-dropdown-status
            [header]="COLUMNTEXT.IDO"
            [data]="idoData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="72"
            [showDropdown]="dropdownOpen[4]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 4)
            "
            (emitStatusChange)="onStatusChangeForDropdowns($event, idoData)"
          >
          </app-table-dropdown-status>
        </th>
        <td
          mat-cell
          *matCellDef="let location; let i = index"
          headers="ido-headers"
        >
          @if (location.ido === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else {
            <img alt="false" [src]="IMAGES.CANCEL" />
          }
        </td>
      </ng-container>

      <!-- API key -->
      <ng-container matColumnDef="apiKey">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-dropdown-status
            [header]="COLUMNTEXT.API_KEY"
            [data]="apiKeyData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="72"
            [showDropdown]="dropdownOpen[5]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 5)
            "
            (emitStatusChange)="onStatusChangeForDropdowns($event, apiKeyData)"
          >
          </app-table-dropdown-status>
        </th>
        <td
          mat-cell
          *matCellDef="let location; let i = index"
          headers="api-key-headers"
        >
          @if (location.apiKey === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else {
            <img alt="false" [src]="IMAGES.CANCEL" />
          }
        </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="action-headers">
          <ion-row class="th-text"> {{ COLUMNTEXT.ACTION }} </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="action-headers"
        >
          <!-- delete operation is still a WIP for back-end and will be disabled until work is completed -->
          <!-- will be set by role from this context -->
          <app-table-action-cell
            [data]="admin"
            [hasDeleteButton]="true"
            [hasEditButton]="true"
            [editButtonDisabled]="!canEditDeleteLocation"
            [deleteButtonDisabled]="true"
            (emitEditButton)="editLocation(admin)"
            (emitDeleteButton)="removeLocationDialog(admin, i)"
          ></app-table-action-cell>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns; let i = index"
      ></tr>
      <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell no-border" [attr.colspan]="displayedColumns.length">
          <app-no-results-found></app-no-results-found>
        </td>
      </tr>
    </table>
  </div>
  <app-table-pagination [datasource]="dataSource"></app-table-pagination>
</body>
